export const ACTIONS = {
  INITIALIZE: 'initialize',
  CHANGE: 'change',
  RESET: 'reset',
  TOGGLE: 'toggle',
} as const;
